import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromProfile from '../../reducers/profile/profile.reducer';
import { ProfileImage } from '../../../models/profile-image.model';

export const selectProfileStateFeature = createFeatureSelector<fromProfile.State>(
  fromProfile.profileFeatureKey
);

export const selectProfileImage = createSelector(
  selectProfileStateFeature,
  (state: fromProfile.State): ProfileImage => {
    return {
      data: state.data
    };
  }
);
